"use strict";

var UIMoney = require('ui-money');
function helper(Handlebars) {
  /**
   * Format number or string with given operation and options.  If the string has
   * a currency name, e.g. "USD 123.00", this is used to determine the default
   * symbol (e.g. $) per https://github.tlcinternal.com/UITools/ui-money
   *
   * Takes the following options:
   * precision, symbol, currency, format
   *
   * @return {String} formatted String that represents currency.
   */
  function currencyFormat(num, options) {
    var opts = options || {
      hash: {}
    };
    var precision = parseInt(opts.hash.precision, 10);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(precision)) {
      precision = 2;
    }
    var currency = opts.hash.currency || opts.hash.symbol;
    var formatOverride = opts.hash.format;
    var roundFn = opts.hash.roundFn;
    if (formatOverride && formatOverride.indexOf('%v') !== -1) {
      // for backwards compatibility with accounting.js format strings used previously
      formatOverride = formatOverride.replace('%s', '¤').replace('%v', '#');
    }
    return new UIMoney(num, currency).format(precision, formatOverride, roundFn);
  }
  Handlebars.registerHelper('currencyFormat', currencyFormat);
  return currencyFormat;
}
module.exports = helper;
